module.exports = __webpack_public_path__ + "img/bloody_mary.4c6fb033.jpg";